import React, { useState, useEffect } from 'react';
import Carousel from '../carousel/Carousel';

const CarouselTemplate = ({ sliders = [], message = '' }) => {
  const [textIndex, setTextIndex] = useState(null);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const currentMessage = message;
  const TYPING_SPEED = 50; // ms par lettre
  const DISPLAY_TIME = 10000; // 10 secondes
  const DELETING_SPEED = 25;
  const getRandomIndex = (excludeIndex) => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * sliders.length);
    } while (newIndex === excludeIndex); // éviter la répétition
    return newIndex;
  };
  useEffect(() => {
    if (sliders.length > 0) {
      const initialIndex = getRandomIndex(-1);
      setTextIndex(initialIndex);
    }
  }, [sliders]);

  useEffect(() => {
    if (sliders.length != 0) {
      let timeout;
      if (!isDeleting) {
        if (displayedText.length < currentMessage.length) {
          timeout = setTimeout(() => {
            setDisplayedText(currentMessage.slice(0, displayedText.length + 1));
          }, TYPING_SPEED);
        } else {
          timeout = setTimeout(() => setIsDeleting(true), DISPLAY_TIME);
        }
      } else {
        if (displayedText.length > 0) {
          timeout = setTimeout(() => {
            setDisplayedText(currentMessage.slice(0, displayedText.length - 1));
          }, DELETING_SPEED);
        } else {
          setIsDeleting(false);
          setTextIndex((prevIndex) => getRandomIndex(prevIndex)); // Choix aléatoire
        }
      }

      return () => clearTimeout(timeout);
    }
  }, [displayedText, isDeleting, textIndex]);

  return (
    <>
      {
        sliders.length === 0 ? (
          <>Loading ...</>
        ) : textIndex !== null && sliders[textIndex] ? (
          <Carousel slides={[sliders[textIndex]]} />
        ) : (
          <>Loading ...</>
        )
      }
    </>
  );
};

export default CarouselTemplate;
